import { Component, signal, OnInit, input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProductStoreSelector } from '@common/selectors/product.selector';

import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { filter, map } from 'rxjs';
import { AnalyticsService } from '@core/services/app/analytics.service';
import { ResetStateService } from '@core/services/reset-state.service';

@Component({
  selector: 'app-kiosk-header-atom',
  templateUrl: './kiosk-header-atom.component.html',
})
export class KioskHeaderAtomComponent extends DestroyerBase implements OnInit {
  readonly logoImageUrl = input<IContentBuilderFieldImage>();
  readonly backgroundColor = input<IContentBuilderFieldColor>();
  readonly backgroundImage = input<IContentBuilderFieldImage>();
  readonly headerLandingText = input<string>();
  readonly displayHomeButton = input<boolean>(false);
  readonly displayLeavingSessionButton = input<boolean>(false);
  readonly buttonHomeText = input<string>();
  readonly buttonBackgroundColor = input<IContentBuilderFieldColor>();
  readonly buttonTextColor = input<IContentBuilderFieldColor>();
  readonly displayLogo = input(false);
  readonly size = input<'L' | 'M' | 'S'>('S');

  protected readonly isLeaving = signal(false);

  hideHomeBtn: boolean = true;

  private readonly activeCategory$ = this.productSelector.selectActiveCategory;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly productSelector: ProductStoreSelector,
    private readonly router: Router,
    private readonly analyticsService: AnalyticsService,
    private readonly resetStateService: ResetStateService,
  ) {
    super();
  }

  ngOnInit() {
    this.checkRoute(this.router.url);

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.checkRoute(this.router.url);
    });
  }

  private checkRoute(currentRoute: string): void {
    this.hideHomeBtn = !currentRoute.includes('product-add');
  }

  getBackgroundStyles() {
    const backgroundColor = this.backgroundColor();
    const backgroundImage = this.backgroundImage();
    return {
      'background-color': backgroundColor ? backgroundColor : null,
      'background-image': backgroundImage ? `url(${backgroundImage.url})` : null,
      'background-size': this.backgroundImage() ? 'cover' : null,
    };
  }

  redirectoToHome(): void {
    const shopCity = this.activatedRoute.snapshot.paramMap.get('shopCity');
    const shopType = this.activatedRoute.snapshot.paramMap.get('shopType');
    const shopSlug = this.activatedRoute.snapshot.paramMap.get('shopSlug');

    this.activeCategory$
      .pipe(
        map(id => {
          this.analyticsService.log({
            level: 'debug',
            label: '#DOOD-1250 Navigate',
            message: {
              from: 'KioskHeaderAtomComponent Ligne°84',
              target: [`/fr/${shopCity}/${shopType}/${shopSlug}${id ? `/categories/${id}` : ''}`],
              currentLocation: window.location.pathname,
            },
          });
          this.router.navigate([
            `/fr/${shopCity}/${shopType}/${shopSlug}${id ? `/categories/${id}` : ''}`,
          ]);
        }),
      )
      .subscribe();
  }

  async leaveSession() {
    this.isLeaving.set(true);
    await this.resetStateService.refreshUIAndResetLang();
  }
}
